const en = {
    'orgChart.button.expand_all': 'Expand all',
    'orgChart.button.collapse_all': 'Collapse all',
    'orgChart.button.add_node': 'Add node',
    'orgChart.button.delete_node': 'Delete node',
    'orgChart.confirm.delete_node': 'Do you want to delete this node?',
    'orgChart.alert.node_deleted': 'Node successfully deleted',
    'orgChart.alert.node_has_children': 'Cannot delete because it has children',
    'orgChart.error.delete_failed': 'An error occurred while deleting',
    'orgChart.title.orgChart': 'Org Chart',
    'orgChart.error.load_failed': 'Error loading org chart data:',
    'orgChart.tab.functional': 'Functional',
    'orgChart.tab.holidays': 'Holidays',
    'orgChart.tab.salaries': 'Salaries',
    'orgChart.tab.extras': 'Extras',
    'orgChart.title.holidayOrgChart': 'Holiday Org Chart',
    'orgChart.description.holidayOrgChart': 'Role and hierarchy view for holiday planning, without employee names.'
};

export default en;